import { localGetItem } from './Services/CacheProviderService';

/** Dispatched when the drawer "Previous data" checkbox changes (Chart + FO Reports + FO Billing Transaction). */
export const BILLING_DATA_TOGGLE_EVENT = 'chartDashboardNewBillingChanged';

/** Login / org flag: when false, always use legacy billing APIs and hide the drawer toggle. */
export function orgHasNewBillingEnabled() {
    return localGetItem("isNewBilling") === "true";
}

/**
 * Chart dashboard: isNewBilling false → always legacy chart APIs.
 * isNewBilling true: not migrated → new APIs; migrated → drawer toggle.
 */
export function chartDashboardUseNewBillingApis() {
    if (!orgHasNewBillingEnabled()) return false;
    if (localGetItem("old_to_new_migrated") !== "true") return true;
    return localGetItem("chart_dashboard_new_billing") !== "false";
}

/**
 * FO reports: isNewBilling false → always legacy report APIs.
 * isNewBilling true: not migrated → new APIs; migrated → drawer toggle (same as chart).
 */
export function foReportsUseNewBillingApis() {
    if (!orgHasNewBillingEnabled()) return false;
    if (localGetItem("old_to_new_migrated") !== "true") {
        return true;
    }
    return localGetItem("chart_dashboard_new_billing") !== "false";
}

/** FO Billing Transaction list/detail APIs: same source-of-truth as FO Reports drawer toggle. */
export function foBillingTransactionUseNewBillingApis() {
    return foReportsUseNewBillingApis();
}

/** Migrated new-billing org viewing legacy data (drawer "Previous data" checked). Ignored when isNewBilling is false. */
export function foBillingTransactionLegacyDataMode() {
    if (!orgHasNewBillingEnabled()) return false;
    if (localGetItem("old_to_new_migrated") !== "true") return false;
    return localGetItem("chart_dashboard_new_billing") === "false";
}

/**
 * FO Billing Transaction: restrict mutating UI when legacy billing is shown.
 * Same toggle as Chart/FO Reports; only for logged-in front_office users.
 */
export function foBillingTransactionLegacyRestricted() {
    if (!foBillingTransactionLegacyDataMode()) return false;
    try {
        const u = JSON.parse(localGetItem("loggedInUserInfo") || "null");
        return u?.module_name === "front_office";
    } catch {
        return false;
    }
}
